import React from 'react';

import { batch } from 'react-redux';

import { PreQualificationStep, setPreQualificationStep } from 'actions';
import { setApplicationType } from 'actions/application';
import { clearCoBorrower } from 'actions/coBorrower';
import { setPrequalificationPortal } from 'actions/prequalificationPortal';
import { Button } from 'components/Buttons/Button';
import FormBody from 'components/FormBody';
import FormHeader from 'components/FormHeader';
import { PhoneIcon } from 'components/Icons';
import { AlreadyHaveActiveApplicationType } from 'enums/AlreadyHaveActiveApplicationType';
import { ApplicationType } from 'enums/ApplicationType';
import { LoanInformationVariables } from 'enums/LoanInformationVariables';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import { useAppDispatch } from 'hooks/useAppDispatch';
import useAppNavigate from 'hooks/useAppNavigate';
import { useAppSelector } from 'hooks/useAppSelector';
import { AppRoutes } from 'routes/routes.enums';

import styles from './AlreadyHaveActiveApplication.module.scss';

const BORROWER_TITLE_TEXT = `It looks like you already have an active application.\n`;
const COBORROWER_TITLE_TEXT =
  'Co-Borrower is not able to apply now.\n' + 'Do you want to proceed with an individual application?';
const PROCEED_INDIVIDUALLY = 'Proceed individually';

interface AlreadyHaveActiveApplicationProps {
  pageType: AlreadyHaveActiveApplicationType;
}

const AlreadyHaveActiveApplication = ({ pageType }: AlreadyHaveActiveApplicationProps) => {
  const navigator = useAppNavigate();
  const dispatch = useAppDispatch();
  const { isIframe } = useAppSelector((state) => state.data);
  const { [LoanInformationVariables.AssignedConsultant]: consultant } = useAppSelector((state) => state.application);

  const renderTitle = () => {
    const handleRedirect = () => {
      navigator(AppRoutes.Dashboard);
    };

    return (
      <>
        {pageType === AlreadyHaveActiveApplicationType.CoBorrower ? (
          <div className={styles.whiteSpacesPreWrap}>{COBORROWER_TITLE_TEXT}</div>
        ) : (
          <>
            <div className={styles.topRow}>{BORROWER_TITLE_TEXT}</div>
            {pageType === AlreadyHaveActiveApplicationType.Borrower && !isIframe && (
              <div>
                <span className={styles.redirectLink} onClick={handleRedirect}>
                  Click here
                </span>{' '}
                to continue.
              </div>
            )}
          </>
        )}
      </>
    );
  };
  const handleProceedIndividually = () => {
    batch(() => {
      dispatch(clearCoBorrower());
      dispatch(setPrequalificationPortal({ confirmCoborrowerEmail: '' }));
      dispatch(setApplicationType(ApplicationType.Individual));
      dispatch(setPreQualificationStep(PreQualificationStep.Contractor));
    });
  };

  return (
    <>
      <FormHeader title={renderTitle()} percent={ProgressBarStatus.Warning} />
      {pageType === AlreadyHaveActiveApplicationType.Borrower && !!isIframe && (
        <FormBody>
          <p className={styles.onceYourCredit}>Please call your HFS loan consultant {consultant?.name}</p>
          {
            <div className={styles.infoContainer}>
              <div>
                <PhoneIcon className={styles.image} />
                <a className={styles.phoneLink} href={`tel:${consultant?.phone}`}>
                  {consultant?.phone}
                </a>
              </div>
            </div>
          }
        </FormBody>
      )}
      {pageType === AlreadyHaveActiveApplicationType.CoBorrower && (
        <Button className={styles.buttonProceedIndividually} onClick={handleProceedIndividually}>
          {PROCEED_INDIVIDUALLY}
        </Button>
      )}
    </>
  );
};

export default AlreadyHaveActiveApplication;
